import React from 'react';

export interface AuthHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  className?: string;
  iconWrapperClassName?: string;
}

const AuthHeader: React.FC<AuthHeaderProps> = ({
  title,
  subtitle,
  icon,
  className = '',
  iconWrapperClassName = 'bg-primary-100 dark:bg-primary-900/20',
}) => {
  return (
    <div className={`text-center ${className}`}>
      {icon && (
        <div
          className={`mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-4 ${iconWrapperClassName}`}
        >
          {icon}
        </div>
      )}
      <h2 className="text-3xl font-bold text-text-primary dark:text-text-dark-primary">{title}</h2>
      {subtitle && (
        <p className="mt-2 text-text-secondary dark:text-text-dark-secondary">{subtitle}</p>
      )}
    </div>
  );
};

export default AuthHeader;
